module.exports = __webpack_public_path__ + "static/img/dualThrottleValveImg.b0d5120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/dualThrottleValveImg.png
// module id = b4vU
// module chunks = 1